import React, { memo, useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';

import { GADataType, IsDisabled } from '../../../types';

import {
  CheckboxAlphabeticalGroup,
  CheckboxAlphabeticalGroupItemsType,
  CheckboxAlphabeticalGroupI18nSearchPlaceholder,
  CheckboxAlphabeticalGroupSearchValue,
  CheckboxAlphabeticalGroupSelectedItemsFetched,
  CheckboxAlphabeticalGroupFetchMoreButton,
  CheckboxAlphabeticalGroupOnSearch,
  CheckboxAlphabeticalGroupOnChange
} from '../../CheckboxAlphabeticalGroup';

type CheckboxAlphabeticalGroupFilterValue = string[] | undefined;

interface CheckboxAlphabeticalGroupFilterProps {
  name: string;
  value: CheckboxAlphabeticalGroupFilterValue;
  onChange: (
    changedFilters: { [name: string]: CheckboxAlphabeticalGroupFilterValue },
    removeFilters?: string[]
  ) => void;
  sortedItems?: CheckboxAlphabeticalGroupItemsType;
  selectedItems?: CheckboxAlphabeticalGroupItemsType;
  itemsFetched?: CheckboxAlphabeticalGroupSelectedItemsFetched;
  i18nSearchPlaceholder?: CheckboxAlphabeticalGroupI18nSearchPlaceholder;
  searchValue?: CheckboxAlphabeticalGroupSearchValue;
  disabled?: IsDisabled;
  fetchMoreButton?: CheckboxAlphabeticalGroupFetchMoreButton;
  onSearch?: CheckboxAlphabeticalGroupOnSearch;
}

function CheckboxAlphabeticalGroupFilter({
  dataGa,
  disabled,
  fetchMoreButton,
  i18nSearchPlaceholder,
  itemsFetched,
  name,
  onChange,
  onSearch,
  searchValue,
  selectedItems,
  sortedItems,
  value
}: CheckboxAlphabeticalGroupFilterProps & GADataType) {
  const handleChange = useCallback<CheckboxAlphabeticalGroupOnChange>(
    (newValue) => {
      onChange({ [name]: newValue }, isEmpty(newValue) ? [name] : []);
    },
    [name, onChange]
  );

  return (
    <CheckboxAlphabeticalGroup
      dataGa={dataGa}
      disabled={disabled}
      fetchMoreButton={fetchMoreButton}
      i18nSearchPlaceholder={i18nSearchPlaceholder}
      itemsFetched={itemsFetched}
      name={name}
      onChange={handleChange}
      onSearch={onSearch}
      searchValue={searchValue}
      selectedItems={selectedItems}
      sortedItems={sortedItems}
      value={value}
    />
  );
}

export default memo(CheckboxAlphabeticalGroupFilter);
